<template>
    <form id="ResumeForm" class="needs-validation" novalidate>
        <div class="row g-3">
            <!-- Radio (Upload Type) -->
            <div class="d-flex align-items-center gap-4 mb-2">
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="resumeFile" value="file" v-model="resume.resumeType"
                        class="custom-control-input" name="resumeType" />
                    <label class="custom-control-label ms-2" for="resumeFile">{{ $Translate('uploadFile')
                        }}</label>
                </div>

                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="resumeURL" value="url" v-model="resume.resumeType"
                        class="custom-control-input" name="resumeType" />
                    <label class="custom-control-label ms-2" for="resumeURL">{{ $Translate('uploadUrl')
                        }}</label>
                </div>
            </div>

            <!-- Label -->
            <div class="d-flex justify-content-start mb-2">
                <label><strong>{{ $Translate('resume') }}:</strong></label>
            </div>

            <!-- File/URL Input -->
            <div class="mb-3">
                <div class="fileArea" v-if="resume.resumeType === 'file'" style="background-color: white;">
                    <input type="file" ref="resumeInput" accept=".pdf" class="form-control" :class="{
                        'is-valid': resumeSubmitted && resumeUploadTypeIsValid,
                        'is-invalid': resumeSubmitted && !resumeUploadTypeIsValid
                    }" @change="handleResumeFileUpload" />
                </div>
                <div class="urlArea" v-if="resume.resumeType === 'url'" style="background-color: white;">
                    <input type="url" style="border: 0px; width: 100%;" :placeholder="$Translate('resumeLink')"
                        v-model="resume.resumeLink" class="form-control" :class="{
                            'is-valid': resumeSubmitted && resumeUploadTypeIsValid,
                            'is-invalid': resumeSubmitted && !resumeUploadTypeIsValid
                        }" />
                </div>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'Course',
    props: {
        resume: Object,
        resumeSubmitted: Boolean,
        resumeFileIsValid: Boolean,
        resumeLinkIsValid: Boolean,
        resumeUploadTypeIsValid: Boolean
    },
    methods: {
        handleResumeFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.$emit('resume-file-uploaded', file);
            }
        },
        resetResumeInput() {
            this.$refs.resumeInput.value = '';
        }
    }
}
</script>

<style scoped>
.col-md-4 {
    text-align: start;
}

.col-md-4 label {
    margin-bottom: 10px;
}

.col-md-4 input,
.col-md-4 select,
.col-md-4 textarea {
    margin-bottom: 12px;
}

.col-md-4 select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url('../../../../dist/assets/select.svg') no-repeat right 0.75rem center;
    background-color: #fff;
    background-size: 16px 16px;
    padding-right: 2rem;
    line-height: 1.5;
    height: calc(1.5em + 0.75rem + 2px);
}

.fileArea,
.urlArea {
    margin-top: 2px;
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 10px;
    text-align: start;
}
</style>